import React from 'react'
import { Button, Flex, Text } from '@workwhile/ui'
import { X } from 'lucide-react'
import { AccordionCard } from 'components/AccordionCard'
import { useRuleDetailContextValue } from '../context/RuleDetailProvider'
import { useRuleDetailWorkflowsContextValue } from '../context/RuleDetailWorkflowsProvider'
import { useRemoveExclusionFlowContextValue } from '../workflows/RemoveExclusionFlow/context/RemoveExclusionFlowProvider'

export const ExclusionsSection = () => {
  const {
    state: { coverageScope, placeExclusions },
  } = useRuleDetailContextValue()

  const { addExclusionFlow } = useRuleDetailWorkflowsContextValue()
  const {
    actions: { remove },
  } = useRemoveExclusionFlowContextValue()

  if (coverageScope !== 'unincorporated_only') return null

  return (
    <AccordionCard
      title={
        <Flex
          justifyContent="space-between"
          alignItems="center"
          gap={2}
          width="100%"
        >
          <Text fontSize={2} color="lightText">
            Place Exclusions ({placeExclusions.length})
          </Text>
          <Button
            variant="secondary"
            kind="small"
            onClick={addExclusionFlow.open}
          >
            Add exclusion
          </Button>
        </Flex>
      }
    >
      {placeExclusions.length === 0 ? (
        <Flex justifyContent="center" p={3}>
          <Text color="lightText">No exclusions.</Text>
        </Flex>
      ) : (
        <Flex flexDirection="column" gap={2} p={3}>
          {placeExclusions.map((geoid) => (
            <Flex
              key={geoid}
              alignItems="center"
              justifyContent="space-between"
            >
              <Text fontFamily="mono">{geoid}</Text>
              <Button variant="text" kind="small" onClick={() => remove(geoid)}>
                <X size={14} />
              </Button>
            </Flex>
          ))}
        </Flex>
      )}
    </AccordionCard>
  )
}
